import { BaseApi } from '@/main/baseApi';
import { checkError } from '@/main/services/httpRequest';

import { Cell } from '../../../main/utils/table';
import { DMS_MODULE, NAME } from './constants';
import { NahradyFilter, UseNahradaInput } from './store/list/types';

class JednotnaFrontaProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	deleteEntitys(data: { zakazkaId: number, zaznamRwids: number[],reserveQuantity: number[], availableQuantity: number[], reservationIds: number[],
					partNumbers: number[], partExtOdpisIds: number[] }) {
		return checkError(this.axiosInstance.delete(`${this.apiPath}Delete`, { data }), true);
	}

	rezervaceNd(ndData: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/RezervaceNd`, ndData);
	}

	odpisNd(ndData: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/OdpisNd`, ndData);
	}

	uploadMovement(ndData: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/UploadMovement`, ndData);
	}

	nahradyTableSchema() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNahradySchema`);
	}

	nahradyTableData(filter: NahradyFilter) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNahrady`, filter);
	}

	useNahrada(ndSNahradou: UseNahradaInput) {
		return this.post(`/${DMS_MODULE}/${NAME}/useNahrada`, ndSNahradou);
	}

	prevedPolozkyNaZakazku(zakazkaId: number | null, rows: Cell[]) {
		return this.post(`/${DMS_MODULE}/${NAME}/prevedPolozkyNaZakazku`, { ZakazkaId: zakazkaId, Rows: rows });
	}

	isOrderComplete(zakazkaId: number | null) {
		return this.fetch(`/${DMS_MODULE}/zakazka/isOrderComplete`, { orderId: zakazkaId });
	}

	isAnyPartInvoice(ndData: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/isAnyPartInvoice`, ndData);
	}

	uploadParts(fileList: any, ZakazkaId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/UploadParts?ZakazkaId=${ZakazkaId}`, file);
	}
}

export const apiProvider = new JednotnaFrontaProvider();
